module.exports = __webpack_public_path__ + "img/trx.618d7d23.svg";